import {Component, Input} from "@angular/core";

@Component({
  selector: "admin-panel-inner",
  templateUrl: "./inner.component.html",
  styleUrls: ["./inner.component.css"]
})
export class AdminPanelInnerComponent {

  @Input() border: string = "";
  @Input() customs: string = "";

}
